import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleOAuthService } from '../../shared/services/google-oauth/google-oauth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center justify-center min-h-screen bg-gray-50">
      <div class="text-center">
        <div
          class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4">
        </div>
        <p class="text-gray-600">{{ statusMessage }}</p>
      </div>
    </div>
    `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AuthCallbackComponent implements OnInit {
  statusMessage = 'Completing Google authentication...';

  constructor(
    private googleOAuthService: GoogleOAuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const query = new URLSearchParams(window.location.search);
    if (!query.get('code') && !query.get('error')) {
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    this.googleOAuthService.checkPendingCallback();
  }
}
